import Chart from 'chart.js/auto';
import { topojson} from "chartjs-chart-geo";
var worldAtlas = require('world-atlas/countries-50m.json');
var centroids = require('world-countries-centroids/dist/countries.geojson');




jQuery(document).ready(function () {
    if (document.getElementById('map_chart') && mapData) {


        const countries = topojson.feature(worldAtlas, worldAtlas.objects.countries).features;

        const pointBackgroundColors = [];
        const data = mapData.map((d) => {

            const country = centroids.features.find((c) => c.properties.ISO === d.iso);
            if (country) {
                pointBackgroundColors.push(d.color);
                return {
                    name: country.properties.COUNTRY,
                    description: country.properties.COUNTRY,
                    latitude: country.geometry.coordinates[1],
                    longitude: country.geometry.coordinates[0],
                    value: Math.round(d.responses, 2),
                    percent: d.percent,
                    score_band_wording: d.score_band_wording,
                    score_band: d.score_band,
                    color: d.color,
                }
            }
        }).filter(e => e);

        const chartConfig = {
            type: 'bubbleMap',
            data: {
                labels: data.map((d) => d.description),
                datasets: [
                    {
                        outline: countries,
                        showOutline: true,
                        backgroundColor: pointBackgroundColors,
                        borderColor: '#322D32',
                        borderWidth: 1,
                        outlineBackgroundColor: '#989698',
                        data: data,
                    },
                ],
            },
            options: {
                plugins: {
                    legend: {
                        display: false,
                    },
                    tooltip: {
                        enabled: false,
                        external: function (context) {
                            const {chart, tooltip} = context;
                            // const d = context.dataset.data[context.dataIndex];
                            const tooltipEl = document.getElementById('map_tooltip');

                            if (tooltip.opacity === 0) {
                                tooltipEl.style.opacity = 0;
                                return;
                            }

                            const dataPoint = tooltip.dataPoints[0];

                            tooltipEl.innerHTML = '<h5>' + dataPoint.raw.name + '</h5> <strong>Responses:</strong> ' + dataPoint.raw.value + ' <br><strong>Score:</strong> ' + Math.round(dataPoint.raw.percent) + '% <br><strong class="' + dataPoint.raw.score_band + '">' + dataPoint.raw.score_band_wording + '</strong>';

                            const position = context.chart.canvas.getBoundingClientRect();

                            tooltipEl.style.opacity = 1;
                            tooltipEl.style.position = 'absolute';
                            tooltipEl.style.left = position.left + window.pageXOffset + tooltip.caretX + 'px';
                            tooltipEl.style.top = position.top + window.pageYOffset + tooltip.caretY + 'px';
                            // tooltipEl.style.font = bodyFont.string;
                            tooltipEl.style.padding = tooltip.padding + 'px ' + tooltip.padding + 'px';
                            tooltipEl.style.pointerEvents = 'none';

                        },
                    },
                },
                scales: {
                    xy: {
                        projection: 'equalEarth',
                        backgroundColor: 'green',
                        color: 'green',
                    },
                    r: {
                        range: [5, 40],
                        mode: 'area',

                    }
                },
            },
        };

        const chart = new Chart(document.getElementById('map_chart').getContext('2d'), chartConfig);
    }
});


